import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { Organization } from '@rossum/api-client/organization';
import { ListResponse } from '@rossum/api-client/utils';
import { api } from '../../../lib/apiClient';

export const QUERY_KEY_SPLIT_ORGANIZATION = 'document-split-organization';

const getFirstResult = (data: ListResponse<Organization>) => data.results[0];

/**
 * The organization of the current user. `/organizations` is a single-result
 * list for a regular user, hence the `select`.
 */
export const useOrganization = () =>
  useQuery({
    queryKey: [QUERY_KEY_SPLIT_ORGANIZATION] as const,
    queryFn: () => api.request(endpoints.organization.list({})),
    select: getFirstResult,
  });
